module.exports = __webpack_public_path__ + "static/soc4-575199b3883e7195383179610cebf571.png";